import { ClockFilled, WarningCircle, ExclamationCircle } from "@/components/icons";
import { Notification, Warning } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";
import { h } from "vue";
import { ref } from "vue";
import useAxios from "./axios";
import useSession from "./session";
import useUtility from "./utility";
import _ from "lodash";
import dayjs from "dayjs";

const useNotification = () => {
  const axios = useAxios();
  const session = useSession();
  const fetching = ref(false);
  const notifications = ref({});
  const details = ref({});
  const dates = ref([]);
  const datesDetail = ref([]);

  const { getAsset, getAvatar } = useUtility();

  const getIcon = (filename) => {
    const files = ["alert", "info", "reminder", "success"];
    const src = files.includes(filename)
      ? getAsset(`notification/${filename}.png`)
      : getAvatar(filename);
    return h("img", { src, width: 24, height: 24 });
  };

  const getNotifications = async () => {
    fetching.value = true;
    try {
      const res = await axios.get(`/notifications`, {
        params: {
          employee_id: session.value.id,
        },
      });
      const data = (await res.data.data) ?? {};
      notifications.value = (await res.data.data) ?? {};

      for (const key in await data) {
        dates.value.push(key);
      }
      dates.value = dates.value.sort((a, b) => {
        const aepoch = dayjs(a).unix();
        const bepoch = dayjs(b).unix();

        return bepoch - aepoch;
      });
    } catch (error) {
      console.log(error);
    } finally {
      fetching.value = false;
    }
  };

  const getDetails = async (filters) => {
    fetching.value = true;
    try {
      const res = await axios.get(`/notifications/detail`, {
        params: {
          employee_id: session.value.id,
          ...filters,
        },
      });
      const data = (await res.data.data) ?? {};
      details.value = (await res.data.data) ?? {};

      for (const key in await data) {
        datesDetail.value.push(key);
      }
      datesDetail.value = datesDetail.value.sort((a, b) => {
        const aepoch = dayjs(a).unix();
        const bepoch = dayjs(b).unix();

        return bepoch - aepoch;
      });
    } catch (error) {
      console.log(error);
    } finally {
      fetching.value = false;
    }
  };

  const getUnread = async () => {
    fetching.value = true;
    try {
      const res = await axios.get(`/notifications/unread`, {
        params: {
          employee_id: session.value.id,
        },
      });
      for (const item of (await res.data.data) ?? []) {
        setTimeout(() => {
          ElNotification({
            title: item.title,
            dangerouslyUseHTMLString: true,
            message: item.path
              ? `${item.content} <a href="${item.path}" class="text-primary font-bold">Cek disini</a>`
              : item.content,
            icon: getIcon(item.icon),
          });
        }, 500);
      }
    } catch (error) {
      console.log(error);
    } finally {
      fetching.value = false;
    }
  };

  const createByTask = async (payload) => {
    const res = await axios.post(`/notifications`, {
      type: "activity",
      employee_id: session.value.id,
      ...payload,
    });
  };

  const createToEmployee = async (payload, employeeID, icon = "success") => {
    const res = await axios.post(`/notifications/employee`, {
      type: "activity",
      employee_id: employeeID ? employeeID : session.value.id,
      icon: icon,
      ...payload,
    });
  };

  const createToRole = async (payload) => {
    const res = await axios.post(`/notifications/role`, {
      type: "activity",
      ...payload,
    });
  };

  const createNotification = async (payloadTask, payloadEmp) => {
    await createByTask(payloadTask);
    await createToEmployee(payloadEmp);

    await getUnread();
  };

  return {
    fetching,
    notifications,
    details,
    dates,
    datesDetail,
    getNotifications,
    getDetails,
    getUnread,
    createNotification,
    createByTask,
    createToEmployee,
    createToRole,
  };
};

export default useNotification;
